import { render, staticRenderFns } from "./BasePartida.vue?vue&type=template&id=033d548a&scoped=true&"
import script from "./BasePartida.vue?vue&type=script&lang=js&"
export * from "./BasePartida.vue?vue&type=script&lang=js&"
import style0 from "./BasePartida.vue?vue&type=style&index=0&id=033d548a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d548a",
  null
  
)

export default component.exports